import * as I18n from 'circe/I18n';
import { morphFormAddressToRequestPayload } from 'domain/batch/sheets/utils';

export const formatRequest = (truckDetails) => {
  const { baseLocation } = truckDetails;
  const { coordinate, city } = morphFormAddressToRequestPayload(baseLocation);
  const { latitude, longitude } = coordinate;
  const {
    truckType,
    license,
    equipmentId,
    vehicleId,
    ownershipType,
    tempClassification,
  } = truckDetails;

  const data = {
    baseLocation: {
      latitude,
      longitude,
    },
    address: city,
    homeCity: city,
    licensePlate: license,
    vehicleName: equipmentId,
    vehicleType: truckType,
    ownershipType,
    tempClassification,
  };

  return { data, vehicleId };
};
